export default __webpack_public_path__ + "stumbler-screens_mobile.138b2162.png";